import { render, staticRenderFns } from "./DescargueDuplicados.vue?vue&type=template&id=5f06d9b4&"
import script from "./DescargueDuplicados.vue?vue&type=script&lang=js&"
export * from "./DescargueDuplicados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports